import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const listDataClassName = DataClassName.LIST
const listEndpoint = PisaDataClassEndpoint.LIST

export function pisaListDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(listDataClassName, {
    title: listDataClassName,
    restApi: createPisaRestApiConfig(listEndpoint),
    attributes,
  })
}
